import { Component, OnInit, Inject, ElementRef, HostListener } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject, concat } from "rxjs";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ViewChild } from "@angular/core";
import { AskForUserInfoService } from "src/app/services/ask-for-user-info.service";
import { MatDialog } from "@angular/material/dialog";
import { AdService } from "src/app/services/ad.service";
declare var jQuery: any;
declare var $: any;
@Component({
  selector: "app-get-user-info",
  templateUrl: "./get-user-info.component.html",
  styleUrls: ["./get-user-info.component.css"],
})
export class GetUserInfoComponent implements OnInit {
  UserInfoForm: FormGroup;
  UsagePermissionData: any;
  errorExist: boolean = false;
  errorMsg: any;
  adShow: boolean;

  countries: string[] = [];
  states: string[] = [];
  usaStates: string[] = [];
  canadaProvinces: string[] = [];
  isZipRequired = false; 



  showOtherInput: boolean = false;

  availableInterests = [
    { category: 'Building & Refrigeration Sciences', value: '01 - Thermodynamics & Psychrometric' },
    { category: 'Building & Refrigeration Sciences', value: '02 - Heat Transfer and Fluid Flow' },
    { category: 'Building & Refrigeration Sciences', value: '03 - Controls, Instruments, Measurement' },
    { category: 'Building & Refrigeration Sciences', value: '04 - Refrigerants, Lubricants, & Refrigerant Systems' },
    { category: 'Operation & Management', value: '10 - Building Operation & Maintenance' },
    { category: 'Operation & Management', value: '11 - Software' },
    { category: 'Operation & Management', value: '12 - Building Automation' },
    { category: 'Operation & Management', value: '13 - Business Management' },
    { category: 'Design & Applications', value: '20 - Building Design & Load Calculations' },
    { category: 'Design & Applications', value: '21 - Insulation, Fenestration, Building Envelope' },
    { category: 'Design & Applications', value: '22 - Large Building Applications' },
    { category: 'Design & Applications', value: '23 - Residential & Small Building Applications' },
    { category: 'Design & Applications', value: '24 - Healthcare Facility Design' },
    { category: 'Design & Applications', value: '25 - Educational Facility Design' },
    { category: 'Design & Applications', value: '26 - Mission Critical Facility Design' },
    { category: 'Design & Applications', value: '27 - Industrial & Manufacturing Facility Design' },
    { category: 'Design & Applications', value: '28 - Institutional & Government Facility Design' },
    { category: 'Design & Applications', value: '29 - Justice Facility Design' },
    { category: 'Design & Applications', value: '30 - Hotel, Motel & Resort Design' },
    { category: 'Design & Applications', value: '31 - Laboratory Systems & Clean Spaces' },
    { category: 'Design & Applications', value: '32 - Electrical Systems' },
    { category: 'Design & Applications', value: '33 - Duct Design & Room Air Distribution' },
    { category: 'Design & Applications', value: '34 - Commissioning & Testing/Balancing' },
    { category: 'Design & Applications', value: '35 - Seismic and Wind Restraint Design' },
    { category: 'Design & Applications', value: '36 - Fire and Smoke Control' },
    { category: 'Design & Applications', value: '37 - Chemical and Biological Remediation' },
    { category: 'Design & Applications', value: '38 - Industrial and Kitchen Ventilation' },
    { category: 'Design & Applications', value: '39 - Hydronic, Steam & Evaporative Equipment & Systems' },
    { category: 'Design & Applications', value: '40 - Plumbing & Service Water Equipment' },
    { category: 'Design & Applications', value: '41 - Fans, Motors & Forced Air Distribution' },
    { category: 'Design & Applications', value: '42 - Radiant Heating & Cooling' },
    { category: 'Design & Applications', value: '43 - Lighting' },
    { category: 'Indoor Environmental Quality', value: '50 - IAQ Procedures' },
    { category: 'Indoor Environmental Quality', value: '51 - Ventilation Requirements & Infiltration' },
    { category: 'Indoor Environmental Quality', value: '52 - Air Cleaning & Odor Control' },
    { category: 'Indoor Environmental Quality', value: '53 - Moisture Management & Control' },
    { category: 'Indoor Environmental Quality', value: '54 - Humidifying & Dehumidifying Equipment' },
    { category: 'Indoor Environmental Quality', value: '55 - Sound & Vibration' },
    { category: 'Indoor Environmental Quality', value: '56 - Physiology' },
    { category: 'Building Sustainability', value: '60 - Energy Analysis & Resource Utilization' },
    { category: 'Building Sustainability', value: '61 - Building Environmental Impacts & Climate' },
    { category: 'Building Sustainability', value: '62 - Applied Heat Pump & Heat Recovery Systems' },
    { category: 'Building Sustainability', value: '63 - Geothermal Heat Pump & Heat Recovery Applications' },
    { category: 'Building Sustainability', value: '64 - Thermal Storage' },
    { category: 'Building Sustainability', value: '65 - District Heating/Cooling & Cogeneration' },
    { category: 'Building Sustainability', value: '66 - Solar Energy Applications' },
    { category: 'Refrigeration', value: '70 - Food & Beverage Refrigeration' },
    { category: 'Refrigeration', value: '71 - Industrial & Transport Refrigeration' },
    { category: 'Refrigeration', value: '72 - Low Temperature Refrigeration' },
    { category: 'Refrigeration', value: '73 - Refrigeration Load Calculations' },
    { category: 'Refrigeration', value: '74 - Refrigeration & AC Equipment Design & Performance' },
  ];
  showProfessionalInput: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private userinfService: AskForUserInfoService,
    private dialogRef: MatDialogRef<GetUserInfoComponent>,
    private adService: AdService
  ) {}

  ngOnInit() {
   this.loadInitialForm();
    //  console.log(this.data);
  }
  onFormSubmit(UserInfoForm: any) {
    if (this.UserInfoForm.status == "INVALID") {
      return false;
    }
    console.log(this.UserInfoForm.value);
    this.userinfService.UserInfoData(this.UserInfoForm.value).subscribe(
      (res: any) => {
        if (res.CheckCon) {
          // Request successfully added
          const uuid = res.uuid;
          sessionStorage.setItem('uuid', uuid);
          
          // Store the form data in localStorage
          const formData = this.UserInfoForm.value;
          localStorage.setItem('userInfoData', JSON.stringify(formData));
          
          this.dialogRef.close({
            userData: this.UserInfoForm.value,
          });
        } else {
          this.errorExist = true;
          this.errorMsg = res.message;
        }
      },
      (err: any) => {
        console.log(err);
      },
      () => {
        console.log('Request completed');
      }
    );
  }  

   // Function to get unique categories from availableInterests
   get interestCategories() {
    return Array.from(new Set(this.availableInterests.map((interest) => interest.category)));
  }

  // Function to get technical interests based on the selected category
  getInterestsByCategory(category: string) {
    return this.availableInterests.filter((interest) => interest.category === category);
  }

  onProfessionalTitle(value: string) {
    this.showProfessionalInput = value === ''
  }

  onPrincipleActivityChange(value: string) {
    // Set showOtherInput to true only when "Other (Please Specify)" is selected
    this.showOtherInput = value === '';
  }
  async loadInitialForm() {
    let lines = [];

    try {
        //localhost only. uncomment below line of codes for prod.
        const data = await $.get("https://www.cloudflare.com/cdn-cgi/trace");
        lines = data ? data.split("\n") : [];
    } catch (error) {
        console.error("Failed to fetch Cloudflare data:", error);
        // Set fallback values if the request fails
        lines = ["", "", "ip=", "", "", "browser="];
    }

    const ipAddressLine = lines[2] ? lines[2].split("=")[1] : "";
    const browserInfoLine = lines[5] ? lines[5].split("=")[1] : "";


      // Setup country/state arrays
    this.countries = [
      'United States', 'Canada','Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica',
      'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan',
      'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin',
      'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil',
      'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi',
      'Cabo Verde', 'Cambodia', 'Cameroon', 'Cayman Islands', 'Central African Republic',
      'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros',
      'Congo', 'Congo (Democratic Republic of the)', 'Cook Islands', 'Costa Rica', 'Croatia', 'Cuba',
      'Cyprus', 'Czechia', 'Côte d\'Ivoire', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
      'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini',
      'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France',
      'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia',
      'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam',
      'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands',
      'Holy See', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran',
      'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan',
      'Kazakhstan', 'Kenya', 'Kiribati', 'Korea (Democratic People\'s Republic of)', 'Korea (Republic of)',
      'Kuwait', 'Kyrgyzstan', 'Lao People\'s Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
      'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Madagascar', 'Malawi', 'Malaysia',
      'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte',
      'Mexico', 'Micronesia (Federated States of)', 'Moldova (Republic of)', 'Monaco', 'Mongolia',
      'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
      'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue',
      'Norfolk Island', 'North Macedonia', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan',
      'Palau', 'Palestine, State of', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines',
      'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda',
      'Réunion', 'Saint Barthélemy', 'Saint Helena, Ascension and Tristan da Cunha', 'Saint Kitts and Nevis',
      'Saint Lucia', 'Saint Martin (French part)', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines',
      'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
      'Sierra Leone', 'Singapore', 'Sint Maarten (Dutch part)', 'Slovakia', 'Slovenia', 'Solomon Islands',
      'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'South Sudan', 'Spain',
      'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Switzerland', 'Syrian Arab Republic',
      'Taiwan', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau',
      'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine',
      'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Uzbekistan', 'Vanuatu',
      'Venezuela (Bolivarian Republic of)', 'Viet Nam', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'
    ];


    this.usaStates = [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
      'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
      'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
      'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
      'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
      'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
      'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
      'Wisconsin', 'Wyoming'
    ];

    this.canadaProvinces = [
      'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
      'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan'
    ];

    this.states = []; // initialize empty, will populate on country change

    this.UserInfoForm = this.formBuilder.group({
        refPublicationGroupId: [this.data[1].idPublicationGroup],
        UsageType: ["view"],
        browser: [browserInfoLine], // Safely fallback for browser info
        ipAddress: [ipAddressLine], // Safely fallback for IP address
        accessType: [null],
        customerId: [this.data[3].idCustomer],
        RefGroupId: [this.data[0].idGroup],
        idPublication: [this.data[2].idPublication],
        publicationTitle: [this.data[2].publicationName],
        emailaddress: [null],
        phoneno: [null],
        passcode: [null],
        organization: [null],
        fullName: [""],
        professionalTitle: [null],
        principleActivity: ['None', Validators.required],
        technicalInterests: [[]],
        specifyProducts: [null],
        receiveInformation: [null],
        productAnnouncement: [null],

        // New fields for location
        country: [''],
        city: [''],
        state: [''], 
        zip: [''],
    });

    const countryControl = this.UserInfoForm.get('country');
  const stateControl = this.UserInfoForm.get('state');
  const zipControl = this.UserInfoForm.get('zip');

  if (countryControl && stateControl && zipControl) {
    countryControl.valueChanges.subscribe((selectedCountry: string) => {
      // Update state list and value
      if (selectedCountry === 'United States') {
        this.states = this.usaStates;
        stateControl.reset();
      } else if (selectedCountry === 'Canada') {
        this.states = this.canadaProvinces;
        stateControl.reset();
      } else {
        this.states = ['Outside the U.S. and Canada'];
        stateControl.setValue('Outside the U.S. and Canada');
      }

      // Update ZIP field validator
      if (selectedCountry === 'United States' || selectedCountry === 'Canada') {
        zipControl.setValidators([Validators.required]);
        this.isZipRequired = true;
      } else {
        zipControl.clearValidators();
        this.isZipRequired = false;
      }
      zipControl.updateValueAndValidity();
    });
  }




  }
}
